import { useQuery } from 'react-query';

import useApiHelper from '../../hooks/useApiHelper';

import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { IApplianceSelection } from '../../types/Appliance/Appliance';
import { applianceQueryKeys } from '../QueryKeys';

export default function useApplianceTypes() {
  const { get } = useApiHelper();

  const applianceTypes = useQuery({
    queryKey: applianceQueryKeys.types(),
    queryFn: () =>
      get<IDefaultResponseWithData<IApplianceSelection>>(
        `/v1/hardware/types`
      ).then((res) => res.data.data),
  });

  return {
    applianceTypes,
  };
}
